import { useEffect } from 'react';

const setTag = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    Object.entries(attrs).forEach(([k, v]) => { if (k !== 'content') el.setAttribute(k, v); });
    document.head.appendChild(el);
  }
  el.setAttribute('content', attrs.content || '');
  return el;
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement('link'); el.setAttribute('rel', rel); document.head.appendChild(el); }
  el.setAttribute('href', href);
};

const SITE = 'Bodegón Mi Barrio';

// Dependency-free SEO head manager: title, description, canonical, Open Graph,
// Twitter cards and optional JSON-LD structured data — updated per route.
export const SEO = ({ title, description, image, type = 'website', jsonLd, noindex = false }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE}` : SITE;
    document.title = fullTitle;
    const url = window.location.origin + window.location.pathname;
    const img = image || '/logo-bodegon.png';

    if (description) setTag('meta[name="description"]', { name: 'description', content: description });
    setTag('meta[name="robots"]', { name: 'robots', content: noindex ? 'noindex, nofollow' : 'index, follow' });
    setLink('canonical', url);

    setTag('meta[property="og:title"]', { property: 'og:title', content: fullTitle });
    if (description) setTag('meta[property="og:description"]', { property: 'og:description', content: description });
    setTag('meta[property="og:type"]', { property: 'og:type', content: type });
    setTag('meta[property="og:url"]', { property: 'og:url', content: url });
    setTag('meta[property="og:image"]', { property: 'og:image', content: img });
    setTag('meta[name="twitter:title"]', { name: 'twitter:title', content: fullTitle });
    if (description) setTag('meta[name="twitter:description"]', { name: 'twitter:description', content: description });
    setTag('meta[name="twitter:image"]', { name: 'twitter:image', content: img });

    let ld = document.getElementById('seo-jsonld');
    if (jsonLd) {
      if (!ld) { ld = document.createElement('script'); ld.type = 'application/ld+json'; ld.id = 'seo-jsonld'; document.head.appendChild(ld); }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) { ld.remove(); }

    return () => { const l = document.getElementById('seo-jsonld'); if (l && jsonLd) l.remove(); };
  }, [title, description, image, type, jsonLd, noindex]);

  return null;
};

export const organizationJsonLd = () => ({
  '@context': 'https://schema.org', '@type': 'Organization', name: SITE,
  url: window.location.origin, logo: window.location.origin + '/logo-bodegon.png',
});

export const breadcrumbJsonLd = (items) => ({
  '@context': 'https://schema.org', '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({ '@type': 'ListItem', position: i + 1, name: it.name, item: window.location.origin + it.path })),
});
